const Blob = require('node-blob');
const axios = require('axios')
const xlsx  = require('xlsx')

module.exports = async function (nameFile)  {
    var nameFile = nameFile.split("/")[2]   
    var fileURL = await downloadfile(nameFile)
    const XLSX = xlsx
    var wb = XLSX.read(fileURL, {
        type: "array",
        cellDates: true,
    });

    return wb
}

async function downloadfile (nameFile) {
    var fileURL
    
    await axios({
        url: "https://safe-net.co/data/api/download-file/" + nameFile,
        method: "POST",
        responseType: "arraybuffer",
      }).then((response) => {
        fileURL = Buffer.from(response.data, "utf-8")
      })

      return fileURL
}